import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import DropdownComponent from '../core/DropdownComponent';
import CounterInput from '../core/CounterInput';
import * as symbols from '../../operations/symbols';
import './orders.scss';
import OrderProductsComponent from "./OrderProductsComponent";

class ProductVerifyCardComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedFilter: { key: 'abc', value: 'abc', sendValue: 'abc' },
      quantityValue: ''
    }

  }

  getValue(val) {
    this.setState({ quantityValue: val })
  }

  componentDidMount() {
    this.setState({ quantityValue: this.props.product.quantityOrdered })
  }

  setQuantityValue(e) {
    this.setState({ quantityValue: e.target.value });
  }

  render() {
    const { product } = this.props;
    let qtyDelivered = product.issue !== null ? product.issue.quantityDelivered : product.quantityDispatched;
    const netGst = product.pricePerUnit * (qtyDelivered) * product.gstRate / 100;
    const totalPrice = product.pricePerUnit * (qtyDelivered) + netGst;
    return (
      <div className="order-card product-card mt-2">
        <div className="product-title">
            <b> {product.skuName} </b>
        <div className="clearfix" />
        </div>
        <div className="light-line" />
        <div className="orders-body products-verify-body">
          <div className="row">
            <div className="col-xs-4">
                <div className="subtitle">
                  Quantity<br/> Ordered
                </div>
                <div className="value">
                  {product.quantityOrdered} { product.unit !== 'count' && product.unit }
                </div>
            </div>
            <div className="col-xs-4">
                <div className="subtitle">
                  Quantity<br/> Dispatched
                </div>
                <div className={"value"}>
                  {product.quantityDispatched} { product.unit !== 'count' && product.unit }
                </div>
            </div>
            <div className="col-xs-4">
                <div className="subtitle">
                  Quantity<br/> Accepted
                </div>
                <div className={qtyDelivered<product.quantityDispatched?"value red-text":"value"}>
                  {qtyDelivered} { product.unit !== 'count' && product.unit }
                </div>
            </div>
          </div>
          <div className="row mt-2 mb-1">
            <div className="col-xs-4">
                <div className="subtitle">
                  Price/Unit
                </div>
                <div className="value">
                  &#8377; {product.pricePerUnit}
                </div>
            </div>
            <div className="col-xs-4">
                <div className="subtitle">
                  Taxes
                </div>
                <div className="value">
                  {netGst}
                </div>
            </div>
            <div className="col-xs-4">
                <div className="subtitle">
                  Total Price
                </div>
                <div className="value">
                  <b> &#8377; {totalPrice} </b>
                </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductVerifyCardComponent;
